import { render, staticRenderFns } from "./HangTags.vue?vue&type=template&id=af5c7dc2&scoped=true"
import script from "./HangTags.vue?vue&type=script&lang=js"
export * from "./HangTags.vue?vue&type=script&lang=js"
import style0 from "./HangTags.vue?vue&type=style&index=0&id=af5c7dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5c7dc2",
  null
  
)

export default component.exports